import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { notification, Popover, Collapse } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@ts-digital/vrc";
import { Link } from "react-router-dom";
import {
  FEATURE_TOGGLE_IMPOSTE,
  FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS,
  FEATURE_TOGGLE_INCASSA_SUBITO,
  FEATURE_TOGGLE_ITEM_ACTIVITIES,
  FEATURE_TOGGLE_DEADLINES_ACTIVITIES
} from "../../config";
import { Toggle } from "@ts-digital/vrc";
import { FormattedMessage } from "react-intl";
import BusinessPerformanceModal from "./businessPerformanceModal";

import {
  getSettingsCompany,
  savePermissions
} from "../../store/actions/permissions";

const excludedSpanishPermissions = [
  "3", // Via Mail
  "16", // Invio Automatico XML
  "19",   // Autorizzare pagamenti e scadenze
  "107",  // Autorizza scadenze fiscali e previdenziali
  "108",  // Autorizza disposizioni di pagamento
  "20",   // Vede scadenze create da fatture
  "78",   // Scadenze
  "106",   // Checkup Impresa
  "62"   // Incassa subito
];

const { Panel } = Collapse;

class Settings extends Component {
  static propTypes = {
    userUuidSelected: PropTypes.string,
    auth: PropTypes.object,
    company: PropTypes.object,
    currentPermissions: PropTypes.object,
    main: PropTypes.object,
    studio: PropTypes.object,
    savePermissions: PropTypes.func
  };

  constructor() {
    super();
    this.state = {
      companyChosen: "",
      settings: [],
      settingsToSave: [],
      activeSettingsIcon: false,
      activeAskIcon: false,
      changeInSettings: false,
      isBusinessPerformanceModalOpen: false
    };
    this.businessPerformanceModalHandler = this.businessPerformanceModalHandler.bind(this);
    this.onCloseBusinessPerformanceModal = this.onCloseBusinessPerformanceModal.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.currentPermissions.permissionClient &&
      nextProps.main.clientIdSelected !== prevState.companyChosen
    ) {
      return {
        companyChosen: nextProps.main.clientIdSelected,
        settings: nextProps.currentPermissions.permissionClient.permissions,
        settingsToSave: []
      };
    }
    if (
      nextProps.currentPermissions.permissionClient &&
      nextProps.currentPermissions.permissionClient.permissions !==
        prevState.settings
    ) {
      return {
        settings: nextProps.currentPermissions.permissionClient.permissions
      };
    }
    return prevState;
  }

  changeCompanyChosen(value) {
    this.setState({
      companyChosen: value
    });

    if (
      document.getElementsByClassName("ant-popover settingsPop ant-popover-placement-bottom zoom-big-leave zoom-big-leave-active").length > 0
    ) {
      document.getElementsByClassName("fa-cog")[0].parentElement.click();
    }
  }

  async changeToggle(
    indexGroup,
    indexFunction,
    functionName,
    value,
    isBusinessPerformance
  ) {
    value = isBusinessPerformance ? !value : value;
    const {
      main,
      userUuidSelected
    } = this.props;
    const { settings, settingsToSave } = this.state;

    let arraySettingsToSave = [];
    let currentSettings = settingsToSave.find(client => {
      return client.permissions[0].itemId === main.companyUuidSelected;
    });

    if (!currentSettings) {
      currentSettings = {
        ownerId: main.accountantUuidSelected ? main.accountantUuidSelected : "",
        permissions: [
          {
            itemId: main.companyUuidSelected,
            userId: userUuidSelected ? userUuidSelected : null,
            actions: []
          }
        ]
      };
    }

    currentSettings.permissions[0].actions.push({
      name: functionName,
      isActive: value ? true : false
    });
    currentSettings.permissions[0].actions = [
      ...currentSettings.permissions[0].actions
        .reverse()
        .filter((
          action, index, self
        ) =>
          index === self.findIndex(a => a.name === action.name))
    ];

    arraySettingsToSave.push(currentSettings);

    let arraySettings = settings;

    arraySettings[indexGroup].permissions[indexFunction].isActive = value
      ? true
      : false;

    this.setState({
      settings: arraySettings,
      settingsToSave: arraySettingsToSave,
      changeInSettings: true
    });
  }

  checkPermissionSaved() {
    const { currentPermissions, user } = this.props;
    
    if (currentPermissions.isPermissionsSaved) {
      this.openSuccessWithIcon(
        "success",
        user?.profile?.language === "es-ES" ? "Configuración guardada correctamente" : "Impostazioni salvate correttamente",
        user?.profile?.language === "es-ES" ? "La configuración se ha guardado correctamente." :"Le impostazioni sono state salvate correttamente."
      );
      return;
    }
    if (currentPermissions.isPermissionsError) {
      this.openSuccessWithIcon(
        "error",
        user?.profile?.language === "es-ES" ? "Ha ocurrido un problema" : "Si è verificato un problema",
        user?.profile?.language === "es-ES" ? "La configuración no se ha guardado correctamente" : "Le impostazioni non sono state salvate correttamente."
      );
      return;
    }

    setTimeout(function() {
      this.checkPermissionSaved();
    }.bind(this),
    100);
  }

  saveThis() {
    const {
      main,
      getSettingsCompany,
      savePermissions
    } = this.props;
    const { settingsToSave } = this.state;
    savePermissions(settingsToSave,
      main.companyUuidSelected)
      .then(res => {
        this.setState({ activeSettingsIcon: false });
        getSettingsCompany();
        // document.getElementsByClassName("fa-cog")[0].parentElement.click();
        this.checkPermissionSaved();
        this.setState({ changeInSettings: false });
        this.setState({ isBusinessPerformanceModalOpen: false });
      })
      .catch(err => {
        getSettingsCompany();
        // document.getElementsByClassName("fa-cog")[0].parentElement.click();
        this.checkPermissionSaved();
      });
  }

  resetAll() {
    this.setState({
      changeInSettings: false
    });
    const {
      getSettingsCompany
    } = this.props;

    getSettingsCompany();
    this.setState({
      isBusinessPerformanceModalOpen: false
    });
  }

  openSuccessWithIcon = (
    type, message, description
  ) => {
    notification[type]({
      message: message,
      description: description,
      duration: 8,
      style: { marginTop: "50px" }
    });
  };

  async reloadPermissions() {
    const {
      main,
      getSettingsCompany
    } = this.props;

    // ? let accountantId = companyStudio ? companyStudio.codiceFiscale : accountantSelected ? accountantSelected : "";

    if (main.companySelected && main.accountantSelected) {
      getSettingsCompany();
    }
  }

  onPopoverVisibleChange(visible) {
    let isActiveSettingsIcon;
    if (!visible) {
      isActiveSettingsIcon = false;
    } else {
      isActiveSettingsIcon = true;
    }
    this.setState({ activeSettingsIcon: isActiveSettingsIcon });
  }

  businessPerformanceModalHandler() {
    this.setState({
      isBusinessPerformanceModalOpen: true
    });
  }

  onCloseBusinessPerformanceModal() {
    this.setState({
      isBusinessPerformanceModalOpen: false
    });
  }

  render() {
    const {
      company,
      main,
      currentPermissions,
      studio,
      user,
      currentPermissions: { isLoadingSettings }
    } = this.props;
    const { settings, companyChosen, changeInSettings } = this.state;

    let studioFind;

    if (main?.accountantUuidSelected) {
      studioFind = studio?.list?.find((x) => x.uuid === main?.accountantUuidSelected) ||
            company?.companies?.find(x => x?.uuid === main?.companyUuidSelected)?.commercialistiList?.find(x => x?.uuid === main?.accountantUuidSelected);
    }

    let color;
    let disabled;
    let findedCompany = company.companies.find(el => {
      return el.id === companyChosen;
    });

    let collapsePanels = [];

    if (currentPermissions.permissionClient && settings?.length > 0) {
      let permissionsGroup = settings;

      const group1 = permissionsGroup.filter(g => g.groupId === "2");
      const group2 = permissionsGroup.filter(g => g.groupId === "1");
      const group3 = permissionsGroup.filter(g => g.groupId === "15");
      const group4 = permissionsGroup.filter(g => g.groupId === "6");
      const group5 = permissionsGroup.filter(g => g.groupId === "7");

      if (
        group1.length === 0 ||
        group2.length === 0 ||
        group3.length === 0 ||
        group4.length === 0 ||
        group5.length === 0
      ) {
        return null;
      }

      const permissionsList1 = group1[0].permissions;
      const permissionsList2 = group4[0].permissions;
      const permissionsList3 = group2[0].permissions;
      const permissionsList4 = group3[0].permissions;
      const permissionsList5 = group5[0].permissions;

      const group1Title = user?.profile?.language === "es-ES" ? "Puede ver" : group1[0].groupLabel.slice(0, 10);
      const group2Title = user?.profile?.language === "es-ES" ? "Puede subir documentos" : group2[0].groupLabel;
      const group3Title = user?.profile?.language === "es-ES" ? "Puede realizar estas acciones" : group3[0].groupLabel;

      const permissionsListStructure = [
        {
          listToIterate: permissionsList1,
          index: 1,
          listLabel: "permissionsList1"
        },
        {
          listToIterate: permissionsList5,
          index: 4,
          listLabel: "permissionsList5"
        },
        {
          listToIterate: permissionsList2,
          index: 3,
          listLabel: "permissionsList2"
        },
        {
          listToIterate: permissionsList3,
          index: 0,
          listLabel: "permissionsList3"
        },
        {
          listToIterate: permissionsList4,
          index: 9,
          listLabel: "permissionsList4"
        }
      ];

      const permissionsListTemplate = permissionsListStructure.map(str => {
        return str.listToIterate.map((perm, index) => {
          if (str.listLabel === "permissionsList1") {
            if (perm.functionId === "21") {
              color = perm.isActive === true ? "#00c3ea" : "#9da6ad";
              disabled = perm.isActive === true ? false : true;
            }
            if (FEATURE_TOGGLE_IMPOSTE !== "true" && perm.functionId === "6") {
              return null;
            }
            if (
              FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS !== "true" &&
              perm.functionId === "21"
            ) {
              return null;
            }
            if (
              FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS !== "true" &&
              perm.functionId === "77"
            ) {
              return null;
            }
            if (
              FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS === "true" &&
              findedCompany &&
              findedCompany.classifier === "PERSON" &&
              perm.functionId === "21"
            ) {
              return null;
            }
            if (
              FEATURE_TOGGLE_INCASSA_SUBITO !== "true" &&
              perm.functionId === "62"
            ) {
              return null;
            }
            if (
              FEATURE_TOGGLE_INCASSA_SUBITO === "true" &&
              findedCompany &&
              findedCompany.classifier === "PERSON" &&
              perm.functionId === "62"
            ) {
              return null;
            }
          }
          if (str.listLabel === "permissionsList3") {
            if (perm.functionId === "17") {
              return null;
            }
          }
          if (str.listLabel === "permissionsList4") {
            if (
              FEATURE_TOGGLE_ITEM_ACTIVITIES !== "true" &&
              perm.functionId === "19"
            ) {
              return null;
            }
            if (
              FEATURE_TOGGLE_DEADLINES_ACTIVITIES !== "true" &&
              perm.functionId === "20"
            ) {
              return null;
            }
          }

          if (studioFind?.taxRegion === "ES" && excludedSpanishPermissions.indexOf(perm?.functionId) > -1){
            return null;
          }

          return (
            <div key={index}>
              <div
                style={{
                  display: perm.functionId === "21" && "flex",
                  alignItems: perm.functionId === "21" && "center",
                  height: "24px",
                  marginBottom:
                    perm.functionId === "77" || perm.functionId === "86"
                      ? "20px"
                      : "10px"
                }}
              >
                <div
                  style={{
                    paddingRight: "20px",
                    display: "inline-block",
                    color: "#000000",
                    fontWeight: "400",
                    width: perm.functionId === "107" ? 280: 260,
                    paddingLeft:
                      str.listLabel === "permissionsList1" ||
                      str.listLabel === "permissionsList2" ||
                      str.listLabel === "permissionsList5"
                        ? "20px"
                        : "0"
                  }}
                >
                  {user?.profile?.language === "es-ES" ? <FormattedMessage id={"permissions." + perm.functionLabel} defaultMessage={perm.functionLabel} /> : perm.functionLabel}
                </div>
                {str.listLabel === "permissionsList1" &&
                  FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS === "true" &&
                  perm.functionId === "21" && (
                  <div style={{ paddingRight: "20px" }}>
                    <button
                      className="managerBpButton"
                      style={{ color: color }}
                      onClick={this.businessPerformanceModalHandler}
                      disabled={disabled}
                    >
                      <FormattedMessage id="settings.manageBusinessPerformanceSettings" />
                    </button>
                  </div>
                )}
                <div style={{ float: "right" }}>
                  <Toggle
                    onChange={this.changeToggle.bind(
                      this,
                      str.index,
                      index,
                      perm.functionName
                    )}
                    checked={perm.isActive === true ? true : false}
                    backgroundStandardColor={"#c9d9e8"}
                  />
                </div>
              </div>
            </div>
          );
        });
      });

      let collapsePanelsStructure = [
        {
          header: group1Title,
          isMultipleGroup: true,
          subHeaders: ["Nella sua home", "Nel suo menu", "Nei suoi documenti"],
          templates: [
            permissionsListTemplate[0],
            permissionsListTemplate[1],
            permissionsListTemplate[2]
          ]
        },
        {
          header: group2Title,
          isMultipleGroup: false,
          subHeaders: [],
          templates: [permissionsListTemplate[3]]
        }
      ];

      if (studioFind?.taxRegion !== "ES"){
        collapsePanelsStructure.push({
          header: group3Title,
          isMultipleGroup: false,
          subHeaders: [],
          templates: [permissionsListTemplate[4]]
        });
      }

      collapsePanels = collapsePanelsStructure.map((panel, index) => {
        const multipleContent = (
          <>
            <h4 className="permissionsSubTitle">{user?.profile?.language === "es-ES" ? "En su página de inicio" : panel.subHeaders[0]}</h4>
            {panel.templates[0]}
            <h4 className="permissionsSubTitle">{user?.profile?.language === "es-ES" ? "En su menú" : panel.subHeaders[1]}</h4>
            {panel.templates[1]}
            <h4 className="permissionsSubTitle">{user?.profile?.language === "es-ES" ? "En sus documentos" : panel.subHeaders[2]}</h4>
            {panel.templates[2]}
          </>
        );
        return (
          <Panel
            header={panel.header}
            key={index}
            className="header-collapse-custom-panel-custom-panel"
          >
            {panel.isMultipleGroup ? multipleContent : panel.templates}
          </Panel>
        );
      });
    }

    if (typeof findedCompany === "undefined") {
      return null;
    }
    const companyName = findedCompany.ragioneSociale;

    let content = isLoadingSettings ? (
      <FontAwesomeIcon
        icon={["far", "circle-notch"]}
        spin
        style={{ fontSize: "30px" }}
      />
    ) : (
      <>
        <div className="popoverContentContainer">
          <div
            style={{
              height: "calc(100vh - 244px)",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
              padding: "34px 28px"
            }}
          >
            <div>
              <h3 className="permissionPopoverTitle">
                {<FormattedMessage id="settings.popoverTitle1" />}{" "}
                <b>{`${companyName}`}</b>{" "}
                {<FormattedMessage id="settings.popoverTitle2" />}
              </h3>
              <h3
                style={{
                  fontSize: "16px",
                  color: "#ffffff",
                  margin: "15px 0px"
                }}
              >
                {this.state.companyChosen && findedCompany
                  ? findedCompany.text
                  : ""}
              </h3>
              <Collapse className="headerSettingsCollapse" bordered={false}>
                {collapsePanels}
              </Collapse>
            </div>
          </div>
          <div className="permissionsPopoverButtonsContainer">
            <div className="permissionsPopoverLink">
              <Link
                style={{ color: "#0090d1" }}
                to={"/impostazioni"}
                onClick={el => {
                  document
                    .getElementsByClassName("fa-cog")[0]
                    .parentElement.click();
                }}
              >
                <FormattedMessage id="settings.goToSettingsPage" />
              </Link>
            </div>
            <div style={{ textAlign: "center" }}>
              <Button
                className="gs-settings-popover-apply permissionsPopoverButton"
                onClick={this.saveThis.bind(this)}
                disabled={!changeInSettings}
              >
                <FormattedMessage id="settings.applyPermissions" />
              </Button>
            </div>
          </div>
        </div>
        <BusinessPerformanceModal
          companyName={companyName}
          currentPermissions={currentPermissions}
          settings={settings}
          changeToggle={this.changeToggle.bind(this)}
          isBusinessPerformanceModalOpen={
            this.state.isBusinessPerformanceModalOpen
          }
          onCloseBusinessPerformanceModal={this.onCloseBusinessPerformanceModal}
          saveBusinessPerformancePermissions={this.saveThis.bind(this)}
          changeInSettings={changeInSettings}
          resetAll={this.resetAll.bind(this)}
          isUser={false}
        />
      </>
    );

    const titleStructure = [
      {
        className: "title-container",
        content: <FormattedMessage id="settings.permissions" />,
        titleClassName: "title"
      }
    ];
    const titleContent = titleStructure.map((t, index) => (      
      <div key={"titleContent_" + index} className={t.className}>
        <h3 className={t.titleClassName}>{t.content}</h3>
      </div>      
    ));

    return main.myType === "STUDIO" ? (
      <div 
        className="dbx-gainsight-tour-settings"
        style={{ display: "flex", height: "100%" }}
      >
        <Popover
          arrowPointAtCenter={true}
          placement="bottom"
          onVisibleChange={this.onPopoverVisibleChange.bind(this)}
          getPopupContainer={trigger => trigger.parentNode}
          overlayClassName="settingsPop"
          title={titleContent}
          content={content}
          trigger="click"
          visible={this.state.activeSettingsIcon}
        >
          <div
            className={
              "divBadge divBadgeBianco " +
              (this.state.activeSettingsIcon ? "active" : null)
            }
            id="settingsIcon"
          >
            <FontAwesomeIcon
              icon={["far", "cog"]}
              style={{ fontSize: "24px" }}
            />
          </div>
        </Popover>
      </div>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    company: state.company,
    currentPermissions: state.currentPermissions,
    main: state.main,
    studio: state.studio,
    surveys: state.ask.surveys,
    user: state.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSettingsCompany: bindActionCreators(getSettingsCompany, dispatch),
    savePermissions: bindActionCreators(savePermissions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
